import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:101
* @route '/teacher/settings/media'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/teacher/settings/media',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:101
* @route '/teacher/settings/media'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::update
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:101
* @route '/teacher/settings/media'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::muxUploadUrl
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:1159
* @route '/teacher/settings/media/mux-upload-url'
*/
export const muxUploadUrl = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadUrl.url(options),
    method: 'post',
})

muxUploadUrl.definition = {
    methods: ["post"],
    url: '/teacher/settings/media/mux-upload-url',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::muxUploadUrl
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:1159
* @route '/teacher/settings/media/mux-upload-url'
*/
muxUploadUrl.url = (options?: RouteQueryOptions) => {
    return muxUploadUrl.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::muxUploadUrl
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:1159
* @route '/teacher/settings/media/mux-upload-url'
*/
muxUploadUrl.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadUrl.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::muxUploadStatus
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:1183
* @route '/teacher/settings/media/mux-upload-status'
*/
export const muxUploadStatus = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadStatus.url(options),
    method: 'post',
})

muxUploadStatus.definition = {
    methods: ["post"],
    url: '/teacher/settings/media/mux-upload-status',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::muxUploadStatus
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:1183
* @route '/teacher/settings/media/mux-upload-status'
*/
muxUploadStatus.url = (options?: RouteQueryOptions) => {
    return muxUploadStatus.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TutorSettingsController::muxUploadStatus
* @see app/Http/Controllers/Teacher/TutorSettingsController.php:1183
* @route '/teacher/settings/media/mux-upload-status'
*/
muxUploadStatus.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: muxUploadStatus.url(options),
    method: 'post',
})

const media = {
    update: Object.assign(update, update),
    muxUploadUrl: Object.assign(muxUploadUrl, muxUploadUrl),
    muxUploadStatus: Object.assign(muxUploadStatus, muxUploadStatus),
}

export default media